import axios from 'axios';
import { getToken } from './auth';
import { setOverdueAlert } from './overdueAlert';
import { getSubdomain } from "../helpers/domain";
import { installDashboardMock } from "../mocks/install";

const api = axios.create({
    baseURL: `${process.env.REACT_APP_URL}`
});

// No-op fora do modo mock (REACT_APP_MOCK=true). Ver src/mocks/install.js.
installDashboardMock(api);

api.interceptors.request.use(async config => {
    config.headers['subdomain'] = getSubdomain();
    const token = getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        
    }
    return config;
});

// O backend recalcula o nível da tarja de inadimplência a cada requisição e
// devolve no header. Ler aqui mantém a tarja em dia sem nenhuma chamada extra.
const readOverdueAlertHeader = (response) => {
    const header = response?.headers?.['x-overdue-alert'];

    if (header === undefined) return;

    setOverdueAlert(header);
};

api.interceptors.response.use((response) => {
    readOverdueAlertHeader(response);
    return response;
}, function (error) {
    readOverdueAlertHeader(error.response);

    if (error.response?.status === 401 && window.location.href.indexOf("login") <= -1) {
        window.location.href="/login";
    }
    return Promise.reject(error);
});

export default api;